<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p v-if="isLoading" class="modal-card-title">Preview is loading <i class="fa fa-spinner fa-spin loading-icon fa-2x fa-fw"></i></p>
            <p v-else class="modal-card-title">{{ file.name }}</p>
        </header>
        <section class="modal-card-body has-text-centered">
            <embed v-if="file.generatedOnTheFly" :src="file.path" class="file-preview" align="middle" />
            <embed v-else-if="file.mime === 'application/pdf'" :src="`https://drive.google.com/viewerng/viewer?embedded=true&url=${file.path}`" class="file-preview" align="middle" />
            <img v-else-if="file.mime.startsWith('image')" :src="file.path" />
            <div v-else>
                <i class="fa fa-file fa-5x"></i>
                <p class="m-10">
                    <span>This file can't be previewed</span>
                    <br>
                </p>
            </div>
        </section>
        <footer class="modal-card-foot">
          <a :href="`${file.path}?dl=1`" class="button is-success" download>Download</a>
          <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
            <div class="action-button-container" v-if="actionButton">
                <button @click.prevent="actionButton.handler" class="button is-pulled-right is-success">{{ actionButton.label }}</button>
            </div>
        </footer>
    </div>
</template>

<script>
    import { get_file_extension } from '../../modules/emails/utils'
    const mimeTypes = ['image/gif', 'image/jpg', 'image/png', 'application/pdf']
    export default {
        props: ['action-button','file'],

        data () {
            return {
                isLoading: false
            }
        },

      methods: {
        updateClose () {
          // console.log(this.$parent, this.$parent.$parent, this.$parent.$parent.$parent)

          return this.$parent.$parent.$emit('update:active', false)
        },
        },

        mounted () {
            if(!this.file.mime || !mimeTypes.includes(this.file.mime)) {
                const ext = get_file_extension(this.file.name)
                switch (ext) {
                    case 'gif':
                        this.file.mime = 'image/gif'
                        break
                    case 'jpg':
                    case 'jpeg':
                        this.file.mime = 'image/jpg'
                        break
                    case 'pdf':
                        this.file.mime = 'application/pdf'
                        break
                    case 'png':
                        this.file.mime = 'image/png'
                }
            }
        }
    }
</script>

<style>
.modal-card {
  width: 100%; }

.action-button-container {
  flex: 1; }

</style>
